var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5L15.6686 9.69711C15.8722 10.4533 15.974 10.8314 16.1749 11.1406C16.3527 11.4141 16.5859 11.6473 16.8594 11.8251C17.1686 12.026 17.5467 12.1278 18.3029 12.3314L24.5 14L18.3029 15.6686C17.5467 15.8722 17.1686 15.974 16.8594 16.1749C16.5859 16.3527 16.3527 16.5859 16.1749 16.8594C15.974 17.1686 15.8722 17.5467 15.6686 18.3029L14 24.5L12.3314 18.3029C12.1278 17.5467 12.026 17.1686 11.8251 16.8594C11.6473 16.5859 11.4141 16.3527 11.1406 16.1749C10.8314 15.974 10.4533 15.8722 9.69711 15.6686L3.5 14L9.69711 12.3314C10.4533 12.1278 10.8314 12.026 11.1406 11.8251C11.4141 11.6473 11.6473 11.4141 11.8251 11.1406C12.026 10.8314 12.1278 10.4533 12.3314 9.69711L14 3.5Z",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlanIcon);
export default __webpack_public_path__ + "static/media/freePlanIcon.a6ef1d7d638a17b3d228b0f1783125a5.svg";
export { ForwardRef as ReactComponent };